import { useEffect, useState } from 'react';
import { campaign } from './campaign';
import '../../styles/Campaign.css';
import '../../styles/CampaignHero.css';

const CLAVE_PLEGADO = 'cn_campana_hero_plegado';

/**
 * Hero de campaña del dashboard (HU-016, lámina 06/07) — se inserta encima
 * de las tarjetas KPI de `AlertasDelDia.jsx`, con altura propia; las
 * tarjetas se corren hacia abajo sin cambiar de tamaño (la única pantalla
 * de las 4 donde "empujar contenido" es la forma correcta, a diferencia
 * del mapa/login que van superpuestos). Sin `configuracion.banner`, no
 * renderiza nada. El plegado/abierto se recuerda en localStorage por
 * usuario (`usuarioId`, obligatorio — quien lo use debe montarlo recién
 * cuando el usuario ya resolvió, así el primer render ya lee la clave
 * correcta en vez de una genérica que después pisaría el valor real).
 */
const CampaignHero = ({ configuracion, usuarioId }) => {
  const clave = `${CLAVE_PLEGADO}_${usuarioId}`;
  const [plegado, setPlegado] = useState(() => {
    try {
      return localStorage.getItem(clave) === '1';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(clave, plegado ? '1' : '0');
    } catch {
      // localStorage puede fallar (modo privado, cuota) — el plegado
      // simplemente no persiste entre sesiones, no rompe nada más.
    }
  }, [clave, plegado]);

  if (!configuracion.banner) return null;

  const altBanner = `${campaign.party} — ${campaign.candidate}${configuracion.slogan ? `, ${configuracion.slogan}` : ''}`;
  const frase = (configuracion.slogan || campaign.headline).toUpperCase();
  const textoMarquesina = `${campaign.pillars.map((p) => p.toUpperCase()).join(' · ')} · ${frase}`;

  return (
    <div className={`ch-hero ${plegado ? 'ch-hero-plegado' : 'ch-hero-abierto'}`}>
      <button
        type="button"
        className="ch-boton-plegar"
        onClick={() => setPlegado((v) => !v)}
        aria-label={plegado ? 'Ver banner de campaña' : 'Plegar banner de campaña'}
        aria-expanded={!plegado}
      >
        {plegado ? <>Ver <i className="fas fa-chevron-down"></i></> : <>Plegar <i className="fas fa-chevron-up"></i></>}
      </button>

      {plegado ? (
        <div className="ch-plegado-contenido">
          <span className="ch-plegado-logo">
            {configuracion.logo && <img src={configuracion.logo} alt="" />}
          </span>
          <div className="ch-marquesina">
            <span className="cn-marquesina-pista">{textoMarquesina} · {textoMarquesina}</span>
          </div>
        </div>
      ) : (
        <div className="ch-abierto-contenido">
          <img src={configuracion.banner} alt={altBanner} className="ch-banner cn-kb" loading="lazy" />
          <div className="ch-mensaje">
            <span className="ch-en-campana">
              <span className="cn-punto-vivo ch-punto"></span>
              EN CAMPAÑA
            </span>
            <p className="ch-tagline">{configuracion.slogan || campaign.tagline}</p>
            <p className="ch-texto-corto">{campaign.headline}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignHero;
